import { Component, OnInit } from '@angular/core';
import { RouterModule, Router } from '@angular/router';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { LeadDetailsService } from '../../../services/lead-details.service';
import { ReferralDataService } from '../../../services/referral-data.service';
import { SectionsService } from '../../../services/sections.service';
import { AuthorizationUtility } from '../../../shared/authorization/auth.utility';
import { AuthorizationService } from '../../../shared/authorization/authorization.service';
import { AuthorizeButtonDirective } from '../../../shared/authorization/authorizeButton.directive';
import { ButtonComponent } from '../../../shared/components/button/button.component';
import { ListTableComponent } from '../../../shared/components/list-table/list-table.component';
import { PAGE_CONSTANTS } from '../../../shared/constants/page.constants';
import {
  ASSOCIATION_TYPE_SEARCH_VALUES,
  ENROLLMENT_TYPE_BACKEND_MAPPINGS,
  STATIC_DATA,
} from '../../../shared/constants/static-data.constants';
import { SharedDataService } from '../../../shared/services/shared-data-service';
import { ParticipantLeadsListComponent } from '../../participant-leads-list/participant-leads-list.component';
import { NzDropDownModule } from 'ng-zorro-antd/dropdown';
import { ListService } from '../../../shared/services/list.service';
import { UserService } from '../../../services/user.service';
import { StorageService } from '../../../services/storage.service';
import { AutoFocusHeaderDirective } from '../../../shared/directives/auto-focus-header.directive';

@Component({
  selector: 'ppl-provider-enrollment-list',
  standalone: true,
  imports: [
    ListTableComponent,
    NzIconModule,
    NzButtonModule,
    RouterModule,
    NzDropDownModule,
    AutoFocusHeaderDirective
  ],
  providers: [ListService],
  templateUrl: './provider-enrollment-list.component.html',
  styleUrl: './provider-enrollment-list.component.css',
})
export class ProviderEnrollmentListComponent extends ParticipantLeadsListComponent implements OnInit {
  override sharedDataKey: string = STATIC_DATA.SHARED_PROVIDER_ENROLLMENT_DATA;
  override pageId: string = PAGE_CONSTANTS.PROVIDER_ENROLLMENT_DATA_GRID_PAGE;
  pastDueTSSearchValues = [{lkpValueName: 'Yes', lkpValueCode: 'Yes'}]
  associationTypeSearchValues = ASSOCIATION_TYPE_SEARCH_VALUES;
  // lkpValueCode must match the stored association_status_lkp text (the search does a Contains on the
  // aggregated statuses). TODO: ideally source from lookup domain 38 instead of hardcoding.
  associationStatusSearchValues = [
    {lkpValueName: 'Association Active', lkpValueCode: 'Association Active'},
    {lkpValueName: 'Association Active with Gap', lkpValueCode: 'Association Active with Gap'},
    {lkpValueName: 'In PPL Review', lkpValueCode: 'In PPL Review'},
    {lkpValueName: 'In Progress', lkpValueCode: 'In Progress'},
    {lkpValueName: 'On Hold Health Assessment', lkpValueCode: 'On Hold Health Assessment'},
    {lkpValueName: 'Paperwork Complete', lkpValueCode: 'Paperwork Complete'},
    {lkpValueName: 'Returned', lkpValueCode: 'Returned'},
    {lkpValueName: 'Suspended - Training', lkpValueCode: 'Suspended - Training'},
  ];
  providerTypes: any[] = [];


  constructor(
    router: Router,
    sectionService: SectionsService,
    referralDataService: ReferralDataService,
    sharedDataService: SharedDataService,
    authUtility: AuthorizationUtility,
    authService: AuthorizationService,
    private leadDetailsService: LeadDetailsService,
    private listService: ListService,
    userService: UserService,
    private storageService: StorageService
  ) {
    super(
      router,
      sectionService,
      referralDataService,
      sharedDataService,
      userService,
      authUtility,
      authService,
    );
  }

  override ngOnInit(): void {
    super.ngOnInit();
    this.listService.getProgramTypes(this.programName).subscribe((data: any) => {
      if(data.responsedata) {
        this.providerTypes = data.responsedata.providerTypes;
      }
    })
  }

  override onNewLead(): void {
    this.router.navigate(['/referralLogic']);
    this.sectionService.setFlow('providers');
    this.sectionService.setEnrollmentType(JSON.stringify([]));
    this.referralDataService.clearReferrralData();
  }

  onNewEnrollment(type: string) {
    // this.router.navigate([`/home/newEnrollmentForm/${type}`]);
    this.router.navigate(['/newReferral']);
    this.sectionService.setFlow('providerEnrollment');
    this.sectionService.setEnrollmentType(JSON.stringify([ENROLLMENT_TYPE_BACKEND_MAPPINGS[type]]));
    this.userService.setLeadEntry('');
    this.userService.setSelectedLead('');
    this.referralDataService.clearReferrralData();
  }

  override rowClicked(rowDetail: any) {
    const program = this.userService.getSelectedProgram();
    this.userService.setLeadEntry('providerEnrollment');
    this.sectionService.setFlow('providerEnrollment');
    this.referralDataService.clearReferrralData();

    this.userService.setSelectedLead(rowDetail.provider_id); //rowDetail.referral_participant_id
    const entrollmentType = rowDetail.associationType ? rowDetail.associationType.split(',').map((t: any) => ENROLLMENT_TYPE_BACKEND_MAPPINGS[t.trim()] || ENROLLMENT_TYPE_BACKEND_MAPPINGS['IR']) : [ENROLLMENT_TYPE_BACKEND_MAPPINGS['IR']];

    this.leadDetailsService
      .fetchLeadDetailsApi(
        'providerEnrollment',
        program ? program.program_code : '',
        rowDetail.provider_id
      )
      .subscribe((data: any) => {
          
        // this.sectionService.setEnrollmentType(
          
        //   JSON.stringify([
        //     ENROLLMENT_TYPE_BACKEND_MAPPINGS[
        //     data?.responsedata?.basicInfo?.providerType
        //     ],
        //    ])
        // );
        this.sectionService.setEnrollmentType(JSON.stringify(entrollmentType));

        if (
          rowDetail.application_status_lkp == 'New Application' ||
          rowDetail.application_status_lkp == 'In Progress'
        ) {


          this.referralDataService.setReferralDetails(data.responsedata);
          setTimeout(() => {

            this.storageService.setProviderId(data?.responsedata?.basicInfo?.providerId);
            this.storageService.setTrackingNumber(data.responsedata?.basicInfo?.trackingNumber);
            this.storageService.setProviderPPLId(data.responsedata?.basicInfo?.providerPPLId);
            this.sectionService.setFlow('providerEnrollment');
            // const providerTypes = [...new Set(data?.responsedata?.participantAssociations.map((e: any) => ENROLLMENT_TYPE_BACKEND_MAPPINGS[e.providerType]))];

            this.router.navigate(['/newReferral']);
          }, 200);
        } else {
          setTimeout(() => {
            this.storageService.setProviderPPLId(data.responsedata?.basicInfo?.providerPPLId);
            this.router.navigate(['/home/providerEnrollmentList/details/'], { state: { navigateTo: '/home/providerEnrollmentList' } });
          }, 200);
        }
      });
  }
}
